export enum SupportedChainId {
    ARBITRUM_SEPOLIA = 421614,
}
